import { useState } from "react";
import ExpenseForm from "./ExpenseForm";
import "./NewExpense.css"
const NewExpense=(props)=>{
    const [isActivated,changeActive]=useState(false);

    const expensedat=(expensedata)=>{
        const edata={
            ...expensedata, // unzipping the objects and adding id to the object(each item)
            // unique id.
            id: Math.random().toString()
        };
        props.onExpense(edata);
    } 

    const changeActivation=()=>{
        changeActive( prev => !prev);
    }

    let curr=<button className="btn" onClick={changeActivation}>ADD EXPENSE💸</button>;
    // the button when the page loads up first time

    if(isActivated===true){ // when we click on addExpense, the new page which comes up
        // the form, where we put in our values.
        curr=<ExpenseForm onExpenseSubmit={expensedat} active={changeActivation}/>;
    }

    return (
        <div className="newex">
            {curr}
        </div>
    );
};

export default NewExpense;